<template lang="pug">
  page(
    main-title="Выгрузка заказов в службы доставки",
  )
    template(slot="description")  Посмотреть информацию по <b>выгрузке</b> заказов и
      |  выгрузить их можно на этой страничке
    div.panel
      div.panel-body
        div.row.margin-bottom-10
          div.col-md-12.OrderTransferList-Actions
            span(v-if="selectedItemsCount") Выбрано заказов – <b>{{ selectedItemsCount }}</b>
            span(v-else) Ничего не выбрано

            button.btn.btn-wide.btn-default.OrderTransferList-Actions-Send(
              @click="send"
              :disabled="selectionIsEmpty"
            ) Выгрузить заказы
            button.btn.btn-wide.btn-default(
              @click="clearSelection"
              :disabled="selectionIsEmpty"
            ) Сбросить выбор
            button.btn.btn-o.btn-wide.btn-danger.hidden(
              @click="remove"
              :disabled="selectionIsEmpty"
            ) Удалить заказы
            button.btn.btn-wide.btn-default(
              @click="exportToExcel"
            ) Скачать в Excel

        div.row.margin-bottom-10.pull-right(v-if="actionResult")
          div.col-md-12
            div.row(v-for="item in actionResult")
              div.col-md-12
                span(:class="item.className") {{ item.message }}
                  template(v-if="item.shopOrderIdList.length") : <b> {{ item.shopOrderIdList.join(', ') }} </b>

        div.row
          div.col-md-12
            table.table.table-hover
              thead
                tr
                  th(style="width: 30px")
                    check-box(:value="eachItemOnPageIsSelected" @input="toggleEachItemOnPageIsSelected")
                  th.center #
                  th Способ доставки
                  th.center ID заказа
                  th.hidden-xs Текущий статус
                  th.hidden-xs Получатель
                  th.hidden-xs Заказ
                  th.hidden-xs Город доствки
              tbody
                tr(v-for="item in orders")
                  td
                    check-box(
                      :value="Boolean(selection[item.id])"
                      @input="value => toggleSingleItemOnPageIsSelected(value, item.id)"
                    )
                  td.center
                    router-link(
                      :to="{ name: 'EditOrder', params: { salesbeatOrderId: String(item.id), item }}"
                    ) {{ item.id }}
                  td {{ item.delivery_method_name }}
                  td.center
                    div(style="margin: 0 5px 5px 0;") {{ item.order.id }}
                    div.visible-xs.OrderTransferList-StatusesContainer
                      div.label(:class="getLabelClass(item.status)") {{ statusChoice[item.status] }}
                      div.label.label-warning.margin-top-5(v-if="item.test_mode") Тестовый
                      div.label.label-danger.margin-top-5(v-if="item.reorder_required") Данные изменились
                  td.hidden-xs.OrderTransferList-StatusesContainer
                     div.label(:class="getLabelClass(item.status)") {{ statusChoice[item.status] }}
                     div.label.label-warning.margin-top-5(v-if="item.test_mode") Тестовый
                     div.label.label-danger.margin-top-5(v-if="item.reorder_required") Данные изменились
                  td.hidden-xs {{ item.recipient.full_name }}
                  td.hidden-xs
                    div(v-for="product in item.products.items")
                      span {{ product.name }}
                      span(v-if="product.quantity>1") &nbsp;({{ product.quantity }} шт.)
                  td.hidden-xs {{ item.city_name }}
        div.row.center
          div.col-md-12
            paging-toolbar(v-model="page", :pages-count="pagesCount")
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import _debounce from 'lodash/debounce';

    import PagingToolbar from '@/lib/components/PagingToolbar';
    import CheckBox from '@/lib/fields/CheckBox';

    const STATUSES_CLASSES = {
        not_started: 'label-default',
        is_sending: 'label-warning',
        sent: 'label-info',
        delivered: 'label-success',
        sending_error: 'label-danger'
    };

    export default {
        name: 'OrdersTransferList',

        mounted() {
            this.debouncedFetchOrders();
        },

        components: {
            CheckBox,
            PagingToolbar
        },

        computed: {
            ...mapGetters({ orders: 'deliveryOrders' }),
            ...mapState({
                pagesCount: state => state.ordersTransfer.pagesCount,
                statusChoice: state => state.ordersTransfer.statusChoice
            }),

            selectedItemsCount() {
                return Object.entries(this.selection).length;
            },
            selectionIsEmpty() {
                return this.selectedItemsCount === 0;
            }
        },

        watch: {
            page() {
                this.debouncedFetchOrders();
            }
        },

        methods: {
            getDataHook() {
                this.page = 1;
                this.debouncedFetchOrders();
            },
            debouncedFetchOrders: _debounce(function() {
                this.$store.dispatch('fetchOrders', { page: this.page })
                    .then(() => {
                        this.eachItemOnPageIsSelected = this.orders.every(({ id }) => this.selection[id]);
                    });
            }, 500),
            getLabelClass(status) {
                return STATUSES_CLASSES[status];
            },

            toggleEachItemOnPageIsSelected(value) {
                this.eachItemOnPageIsSelected = value;

                if (value) {
                    for (const order of this.orders) {
                        this.$set(this.selection, order.id, value);
                    }
                } else {
                    for (const order of this.orders) {
                        this.$delete(this.selection, order.id);
                    }
                }
            },
            toggleSingleItemOnPageIsSelected(value, itemId) {
                if (value) {
                    this.$set(this.selection, itemId, value);
                } else {
                    this.$delete(this.selection, itemId);

                    if (this.eachItemOnPageIsSelected) {
                        this.eachItemOnPageIsSelected = false;
                    }
                }
            },
            clearSelection() {
                this.selection = {};
            },

            exportToExcel() {
                document.location.href = '/delivery_order/orders/excel/';
            },

            send() {
                this.resetActionResult();

                this.$store.dispatch('sendDeliveryOrders', {
                    selectedItemsIdList: Object.keys(this.selection)
                }).then(({ success, data, orders_errors: ordersErrors, errors }) => {
                    if (success) {
                        this.updateActionResult(data, this.groupErrorsByCode(ordersErrors));
                        this.$store.commit(
                            'updateOrdersStatuses',
                            Object.fromEntries(data.map(item => [ item.salesbeat_order_id, item.status ]))
                        );
                    } else {
                        this.updateActionResult([], errors);
                    }
                });
            },
            remove() {
                this.resetActionResult();

                this.$store.dispatch('deleteDeliveryOrders', {
                    selectedItemsIdList: Object.keys(this.selection)
                });
            },

            updateActionResult(ordersWithSuccess, ordersWithErrors) {
                let actionResult = [];

                if (ordersWithSuccess.length) {
                    actionResult.push({
                        message: `Успешно выгружен${ordersWithSuccess.length > 1 ? 'ы' : ''}`,
                        className: 'text-success',
                        shopOrderIdList: ordersWithSuccess.map(i => i.order_id)
                    });
                }

                if (ordersWithErrors.length) {
                    actionResult = actionResult.concat(
                        ordersWithErrors.map(({ message, shopOrderIdList = [] }) => ({
                            message,
                            shopOrderIdList,
                            className: 'text-danger'
                        }))
                    );
                } else {
                    this.clearSelection();
                }

                this.actionResult = actionResult;
            },
            resetActionResult() {
                this.actionResult = [];
            },

            groupErrorsByCode(ordersWithErrors) {
                const result = {};

                for (const errorList of Object.values(ordersWithErrors)) {
                    for (const { field, code, message, shop_order_id: shopOrderId } of errorList) {
                        const fieldAndCodeJSON = JSON.stringify([ field, code ]);
                        if (fieldAndCodeJSON in result) {
                            result[fieldAndCodeJSON].shopOrderIdList.push(shopOrderId);
                        } else {
                            result[fieldAndCodeJSON] = {
                                message,
                                shopOrderIdList: [ shopOrderId ]
                            };
                        }
                    }
                }

                return Object.values(result);
            }
        },

        data() {
            return {
                page: 1,

                eachItemOnPageIsSelected: false,
                selection: {},

                actionResult: []
            };
        }
    };
</script>

<style lang="stylus">
  $block = '.OrderTransferList'

  {$block}-Actions
    display: flex
    /*align-items: center*/

  /*{$block}-Actions-Send
    margin-left: auto*/

  @media (min-width:768px)
    {$block}-Actions
      align-items: center

    {$block}-Actions > button:not({$block}-Actions-Send)
      margin-left: 5px

    {$block}-Actions-Send
      margin-left: auto

  @media (max-width:767px)
    {$block}-Actions
      flex-direction: column

    {$block}-Actions > button
      margin-top: 5px

  {$block}-StatusesContainer .label
    display block
</style>



// WEBPACK FOOTER //
// src/components/ordersTransfer/OrdersTransferList.vue